import { createReducer } from "@reduxjs/toolkit";

import { SharedStateType, LoadingSections, ModalProps, OverlayProps } from "../interfaces";
import * as actions from "./actions";

export const initialState: SharedStateType = {
  loading: false,
  notification: null,
  modal: undefined,
  overlay: undefined,
  navigateURL: "",
  location: null,
  loadingSections: {},
  loadingTypes: [],
};

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(actions.startLoading, (state) => {
    state.loading = true;
  });
  builder.addCase(actions.stopLoading, (state) => {
    state.loading = false;
  });
  builder.addCase(actions.showModal, (state, action) => {
    state.modal = { ...action.payload };
  });
  builder.addCase(actions.updateModal, (state, action) => {
    if (state.modal) {
      state.modal = { ...state.modal, ...action.payload } as ModalProps;
    }
  });
  builder.addCase(actions.hideModal, (state) => {
    state.modal = undefined;
  });
  builder.addCase(actions.hideOverlay, (state) => {
    state.overlay = undefined;
  });
  builder.addCase(actions.showOverlay, (state, action) => {
    state.overlay = action.payload;
  });
  builder.addCase(actions.updateOverlay, (state, action) => {
    if (state.overlay) {
      state.overlay = { ...state.overlay, ...action.payload } as OverlayProps;
    }
  });
  builder.addCase(actions.showNotification, (state, action) => {
    state.notification = action.payload;
  });
  builder.addCase(actions.navigate, (state, action) => {
    state.navigateURL = action.payload;
  });
  builder.addCase(actions.addLoadingType, (state, action) => {
    state.loadingTypes = [...state.loadingTypes, action.payload];
  });
  builder.addCase(actions.removeLoadingType, (state, action) => {
    state.loadingTypes = state.loadingTypes.filter(({ name }) => name !== action.payload);
    state.loadingSections = {};
  });
  builder.addCase(actions.addLoadingSection, (state, action) => {
    const loadingSections: LoadingSections = { ...state.loadingSections };

    if (!loadingSections[action.payload.loadingSection]) {
      loadingSections[action.payload.loadingSection] = [];
    }

    loadingSections[action.payload.loadingSection] = [
      ...Array.from(new Set([...loadingSections[action.payload.loadingSection], action.payload.requestName])),
    ];

    state.loadingSections = loadingSections;
  });
  builder.addCase(actions.removeLoadingSection, (state, action) => {
    const loadingSections = { ...state.loadingSections };

    if (loadingSections[action.payload.loadingSection]) {
      loadingSections[action.payload.loadingSection] = loadingSections[action.payload.loadingSection].filter(
        (loadingRequest) => loadingRequest !== action.payload.requestName,
      );

      if (!loadingSections[action.payload.loadingSection].length) {
        delete loadingSections[action.payload.loadingSection];
      }

      state.loadingSections = loadingSections;
    }
  });
});

export { reducer as SharedReducer };
